import {
  COMMUNITY_ADS_INTERACTION_TYPES,
  COMMUNITY_INTERACTION_TYPES,
  COMMUNITY_PLATFORM_FILTER_WIDGET,
} from '@/app/community/constants';

export type InteractionAccess = Record<
  | 'instagramComments'
  | 'instagramDirect'
  | 'tikTokComments'
  | 'facebookComments'
  | 'facebookMessenger'
  | 'twitterMentions'
  | 'twitterDirect'
  | 'youTubeComments',
  boolean
>;

// Permission → interaction-type map; useEnabledTypes is the only consumer
export function buildEnabledInteractionTypes(access: InteractionAccess): string[] {
  const types = [];
  if (access.instagramComments) {
    types.push(COMMUNITY_INTERACTION_TYPES.INSTAGRAM_COMMENT);
    types.push(COMMUNITY_ADS_INTERACTION_TYPES.INSTAGRAM_ADS_COMMENT);
  }
  if (access.instagramDirect) {
    types.push(COMMUNITY_INTERACTION_TYPES.INSTAGRAM_CONVERSATION);
  }
  if (access.tikTokComments) {
    types.push(COMMUNITY_INTERACTION_TYPES.TIKTOK_COMMENT);
    types.push(COMMUNITY_INTERACTION_TYPES.TIKTOK_COMMENT_MENTION);
  }
  if (access.facebookComments) {
    types.push(COMMUNITY_INTERACTION_TYPES.FACEBOOK_COMMENT);
    types.push(COMMUNITY_ADS_INTERACTION_TYPES.FACEBOOK_ADS_COMMENT);
  }
  if (access.facebookMessenger) {
    types.push(COMMUNITY_INTERACTION_TYPES.FACEBOOK_CONVERSATION);
  }
  if (access.twitterMentions) {
    types.push(COMMUNITY_INTERACTION_TYPES.TWITTER_MENTION);
    types.push(COMMUNITY_INTERACTION_TYPES.TWITTER_RETWEET);
    types.push(COMMUNITY_INTERACTION_TYPES.TWITTER_QUOTE);
  }
  if (access.twitterDirect) {
    types.push(COMMUNITY_INTERACTION_TYPES.TWITTER_CONVERSATION);
  }
  if (access.youTubeComments) {
    types.push(COMMUNITY_INTERACTION_TYPES.YOUTUBE_COMMENT);
  }
  return types;
}

export function buildEnabledPlatforms(access: InteractionAccess): string[] {
  const platforms = [];
  if (access.facebookComments || access.facebookMessenger) {
    platforms.push(COMMUNITY_PLATFORM_FILTER_WIDGET.FACEBOOK.value);
  }
  if (access.instagramComments || access.instagramDirect) {
    platforms.push(COMMUNITY_PLATFORM_FILTER_WIDGET.INSTAGRAM.value);
  }
  if (access.tikTokComments) {
    platforms.push(COMMUNITY_PLATFORM_FILTER_WIDGET.TIKTOK.value);
  }
  if (access.twitterMentions || access.twitterDirect) {
    platforms.push(COMMUNITY_PLATFORM_FILTER_WIDGET.TWITTER.value);
  }
  if (access.youTubeComments) {
    platforms.push(COMMUNITY_PLATFORM_FILTER_WIDGET.YOUTUBE.value);
  }
  return platforms;
}
